// @ts-nocheck
import { Copy } from 'education-icons';
import { Button, Link, SimpleCallback, SimpleText, useIntl } from 'platform-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import ym from 'react-yandex-metrika';

import copyLessonModalActions from 'common.components/copy-lesson-modal/actions';
import { getCurrentYearCourseId } from 'common.components/course/selectors';
import * as lessonViewActions from 'common.components/lesson-view.store/actions';
import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';
import * as lessonSelectors from 'common.components/lesson/selectors';

import { SidePanelControlTypeProps } from '../typings';

interface Props extends SidePanelControlTypeProps {
    isCopyingEnabled?: boolean;
    onCopyLesson: SimpleCallback;
}

export const SidePanelControlsTypeCopyLesson = React.memo((props: Props) => {
    const { isCopyingEnabled, onCopyLesson, notifyCanBeRender, notifyCanNotBeRender } = props;
    const dispatch = useDispatch();
    const { search } = useLocation();
    const { name } = useSelector(lessonSelectors.getLesson) || {};
    const clessonId = useSelector(lessonSelectors.getCLessonId);
    const canCopyLesson = useSelector((storeState) =>
        lessonViewSelectors.getShouldShowCopyLessonControl(storeState, { isCopyingEnabled, search })
    );
    const courseId = useSelector(getCurrentYearCourseId);
    const activeSubscriptionSlug = useSelector((store) => {
        return lessonSelectors.getLessonActiveSubscriptionSlug(store, { courseId });
    });
    const intl = useIntl();
    const history = useHistory();

    if (!canCopyLesson) {
        notifyCanNotBeRender();
        return null;
    }

    notifyCanBeRender();

    const handleCopyLesson = () => {
        if (!clessonId) {
            return;
        }

        dispatch(lessonViewActions.toggleLessonNotification(false));
        dispatch(lessonViewActions.setSelectedStudentId(null));

        ym('reachGoal', 'teacher_lesson_preview_copy', {
            clessonId,
            subscription_slug: activeSubscriptionSlug,
        });

        dispatch(
            copyLessonModalActions.copyCLesson({
                sourceId: clessonId,
                newName: intl.formatMessage({ id: 'lesson.copyNewName' }, { name }),
                intl,
                history,
            })
        );

        onCopyLesson();
    };

    return (
        <Link mix="qa_copy-lesson" onClick={handleCopyLesson} pseudo>
            <Button accent={Button.ACCENT.NORMAL} icon={<Copy />} view={Button.VIEW.CLEAR}>
                <SimpleText id="lessonModal.header.copyCLesson" />
            </Button>
        </Link>
    );
});
